module.exports = __webpack_public_path__ + "img/scanQrCropped.f0d27320.png";